import React, { useState, useEffect, useRef,useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetProformaInvoiceList,
  DeleteProformaInvoice,
  DownloadProformaInvoicePdf,
  GenerateProformaIrn,
  ListProformaParties,
  GetProformaSettings,
} from "../../store/slices/proforma-invoice";
import Loader from "../../common/Loader";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Table from "../../common/Table";
import AdminLayout from "../AdminLayout";
import { toast } from "react-hot-toast";
import {
  API_BASE_URL,
  API_PATHS,
  CommonImgUploadService_pdf_BASE_URL,
} from "../../utils/constants/api.constants";
import { FaFilePdf } from "react-icons/fa6";
import { FaFileExcel, FaFileDownload } from "react-icons/fa";
import { excelDownload } from "../../common/ExcelDownload";

const InvoiceList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [settings, setSettings] = useState(false); // To store e-invoice settings as boolean
  const [invoicelist, setInvoicelist] = useState([]);
  const [listParties, setListParties] = useState([]);
  const [selectedParty, setSelectedParty] = useState(null); // For ledger_id
  const [selectedRows, setSelectedRows] = useState([]); // Stores selected row IDs
  const [selectAll, setSelectAll] = useState(false);


const columns = useMemo(() => {
  const baseColumns = [
    { header: "Checkbox", field: "Checkbox" },
    { header: "Invoice #", field: "invoice_combined" },
    { header: "Date", field: "invoice_date" },
    { header: "Party", field: "party_name" },
    { header: "CGST", field: "cgst" },
    { header: "SGST", field: "sgst" },
    { header: "IGST", field: "igst" },
    { header: "Total Amount", field: "grand_total" },
    // { header: "Paid Amount", field: "paid_amount" },
    // { header: "Pending Amount", field: "balance_amount" },
  ];

  // Conditionally add IRN fields
  if (settings) {
    baseColumns.push(
      { header: "IRN Number", field: "irn" },
      { header: "Acknowledge Number", field: "ack_no" },
      { header: "Acknowledge Date", field: "ack_date" }
    );
  }

  // Always add Actions column
  baseColumns.push({
    header: "Actions",
    field: "actions",
    isAction: true,
    getActionButtons: (row) => {
      const buttons = [];
      console.log("settings", settings);

      if (!settings) {
        return [
          { name: "Edit", className: "btn-default" },
          { name: "Delete", className: "btn-cancel" },
          // {
          //   className: "btn-danger mt-1",
          //   icon: <FaFilePdf style={{ fontSize: "15px" }} />,
          // },
        ];
      } else {
        if (row.irn) {
          buttons.push(
            { name: "View Invoice", className: "btn-secondary" },
            {
              className: "btn-danger mt-1",
              icon: <FaFilePdf style={{ fontSize: "15px" }} />,
            }
          );
        } else {
          buttons.push(
            { name: "Edit", className: "btn-default" },
            { name: "Delete", className: "btn-cancel" },
            {
              className: "btn-danger mt-1",
              icon: <FaFilePdf style={{ fontSize: "15px" }} />,
            },
            { name: "Generate E-invoice", className: "btn-success mt-1" }
          );
        }
        return buttons;
      }
    },
  });

  return baseColumns;
}, [settings]);



  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const partyOptions = listParties.map((party) => ({
    value: party.id,
    label: party.ledger,
  }));

  // Load saved financial year and dates from localStorage
  const loadSavedDates = () => {
    const savedFinancialYear = localStorage.getItem("selectedFinancialYear");

    // Ensure financial year is always correctly structured
    let startYear, endYear;
    if (savedFinancialYear && savedFinancialYear.includes("-")) {
      [startYear, endYear] = savedFinancialYear.split("-");
    } else {
      // Default to the current financial year
      const currentYear = new Date().getFullYear();
      startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
      endYear = currentYear; // Example: 2025 (for 2024-2025)
    }

    return {
      financialYear: savedFinancialYear || `${startYear}-${endYear}`,
      fromDate: localStorage.getItem("savedFromDate") || `${startYear}-04-01`,
      toDate: localStorage.getItem("savedToDate") || `${endYear}-03-31`,
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  };

  // console.log(loadSavedDates())
  const {
    fromDate: initialFromDate,
    toDate: initialToDate,
    minDate,
    maxDate,
    financialYear: initialFinancialYear,
  } = loadSavedDates();

  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);
  const [financialYear, setFinancialYear] = useState(initialFinancialYear);

  useEffect(() => {
    if (!financialYear) return;

    localStorage.setItem("selectedFinancialYear", financialYear);

    let startYear, endYear;
    if (financialYear.includes("-")) {
      [startYear, endYear] = financialYear.split("-");
    } else {
      return; // Exit if financial year is not valid
    }

    const savedFromDate =
      localStorage.getItem("savedFromDate") || `${startYear}-04-01`;
    const savedToDate =
      localStorage.getItem("savedToDate") || `${endYear}-03-31`;

    setFromDate(savedFromDate);
    setToDate(savedToDate);

    if (!localStorage.getItem("savedFromDate"))
      localStorage.setItem("savedFromDate", savedFromDate);
    if (!localStorage.getItem("savedToDate"))
      localStorage.setItem("savedToDate", savedToDate);
  }, [financialYear]);

  const fetchParties = async () => {
    try {
      const data = await dispatch(ListProformaParties({ profile_id: id })).unwrap();
      setListParties(data?.data);
    } catch (error) {
      console.log("Error fetching parties:", error.message);
    }
  };

  const fetchSettings = async () => {
    try {
      const data = await dispatch(GetProformaSettings({ profile_id: id })).unwrap();
      const e = data?.data?.e_invoice;
      setSettings(e === true || e === 1 || e === "1");
    } catch (error) {
      console.log("Error fetching parties:", error.message);
    }
  };

  const fetchInvoices = async () => {
    setIsLoading(true);
    const params = {
      profile_id: id,
      from_date: fromDate,
      to_date: toDate,
      ledger_id: selectedParty?.value || "",
    };
    // console.log(params)
    try {
      const data = await dispatch(GetProformaInvoiceList(params)).unwrap();
      setIsLoading(false);
      setInvoicelist(data?.data);
    } catch (error) {
      setIsLoading(false);
      setInvoicelist([]);
      console.log("Error fetching invoices:", error.message);
    }
  };

  const fetchIRN = async (invoiceId) => {
    setIsLoading(true);
    const params = {
      profile_id: id,
      invoice_id: invoiceId,
    };
    // console.log("Generating E-invoice for:", invoiceId, params);
    try {
      const data = await dispatch(GenerateProformaIrn(params)).unwrap();
      toast.success(data?.message);
      fetchInvoices(); // Refresh the invoice list after generating IRN
      setIsLoading(false);

      // console.log("IRN generated:", data);
    } catch ({ message }) {
      toast.error(message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchParties();
    fetchSettings();
    fetchInvoices();
  }, [financialYear]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    navigate(`/edit-proforma-invoice/${item.id}`, {
      state: { isViewMode: false },
    });
  };

  const handleView = (item) => {
    navigate(`/edit-proforma-invoice/${item.id}`, {
      state: { isViewMode: true },
    });
  };

  const handleGenerateEinvoice = (item) => {
    fetchIRN(item?.id);
  };

  const handleDelete = (item) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this invoice?"
    );
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(DeleteProformaInvoice({ id: item.id, profile_id: id }))
        .unwrap()
        .then(() => {
          setIsLoading(false);
          fetchInvoices(); // Refresh the invoice list
        })
        .catch(({ message }) => {
          // console.log(message)
          setIsLoading(false);
          toast.error(message);
        });
    }
  };

  const handlePDF = (item) => {
    const data = `${API_BASE_URL}${API_PATHS.invoicespdf}/${item?.id}`;
    navigate("/Pdf-Viewer", { state: { data } });
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchInvoices();
  };

  const filtereditemList = invoicelist?.filter(
    (party) =>
      party?.invoice_number
        ?.toLowerCase()
        ?.includes(searchQuery?.toLowerCase()) ||
      party?.invoice_date
        ?.toLowerCase()
        ?.includes(searchQuery?.toLowerCase()) ||
      party?.billing_state
        ?.toLowerCase()
        ?.includes(searchQuery?.toLowerCase()) ||
      party?.party_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.grand_total
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchQuery?.toLowerCase())
  );

  const handleExcelDownload = () => {
    const selectedInvoices = selectAll
      ? invoicelist.map((invoice) => invoice.id)
      : selectedRows;

    if (!selectedInvoices || selectedInvoices.length === 0) {
      alert("Please select at least one invoice.");
      return;
    }

    const selectedData = invoicelist.filter((invoice) =>
      selectedInvoices.includes(invoice.id)
    );

    if (selectedData.length === 0) {
      alert("No matching invoices found.");
      return;
    }

    try {
      excelDownload(selectedData, "Invoices.xlsx");
      toast.success("Downloading Excel file successfully!");
    } catch (error) {
      console.error("Error downloading Excel file:", error);
      alert("Failed to download the Excel file. Please try again.");
    }
  };

  const handlePdfDownload = async () => {
    const selectedInvoices = selectAll
      ? invoicelist.map((invoice) => invoice.id)
      : selectedRows;

    if (!selectedInvoices || selectedInvoices.length === 0) {
      alert("Please select at least one invoice.");
      return;
    }

    try {
      setIsLoading(true);

      // Make sure this dispatch returns raw binary (ArrayBuffer or Blob)
      const response = await dispatch(
        DownloadProformaInvoicePdf({ ids: selectedInvoices })
      ).unwrap();
      setIsLoading(false);

      // If the response is raw binary data (e.g., ArrayBuffer or base64), convert it to Blob
      const blob = new Blob([response], { type: "application/pdf" });

      // Create a link and auto-click it to download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "invoices.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Cleanup
      window.URL.revokeObjectURL(url);
    } catch (error) {
      setIsLoading(false);
      console.error("Error downloading PDF file:", error);
      alert("There was an error downloading the PDF.");
    }
  };

  // Handle date changes with validation
  const handleFromDateChange = (e) => {
    const newDate = e.target.value;
    if (newDate >= minDate && newDate <= maxDate) {
      setFromDate(newDate);
      localStorage.setItem("savedFromDate", newDate);
    } else {
      toast.error(
        `Select a date within the financial year ${formatFinancialYear(
          minDate,
          maxDate
        )}`
      );
    }
  };

  const handleToDateChange = (e) => {
    const newDate = e.target.value;
    if (newDate >= minDate && newDate <= maxDate) {
      setToDate(newDate);
      localStorage.setItem("savedToDate", newDate);
    } else {
      toast.error(
        `Select a date within the financial year ${formatFinancialYear(
          minDate,
          maxDate
        )}`
      );
    }
  };

  const formatFinancialYear = (startDate, endDate) => {
    return `(${startDate.split("-").reverse().join("-")} to ${endDate
      .split("-")
      .reverse()
      .join("-")})`;
  };


  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5"> Proforma Invoices</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Sale</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Proforma Invoice List
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="btn ripple btn-default"
                onClick={() => navigate("/add-proforma-invoice")}
              >
                Add New Proforma Invoice
              </button>
              {/* <button
                className="btn ripple btn-default"
                onClick={handleExcelDownload}
              >
                Export Excel <FaFileExcel />
              </button>
              <button
                className="btn ripple btn-default"
                onClick={handlePdfDownload}
              >
                <FaFileDownload /> Download Invoices
              </button> */}
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <form onSubmit={handleFilterSubmit} className="row mb-4">
                    <div className="col-md-3">
                      <label>Customer</label>
                      <Select
                        options={partyOptions}
                        placeholder="--Select Customer--"
                        value={selectedParty}
                        onChange={setSelectedParty}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={handleFromDateChange}
                        min={minDate}
                        max={maxDate}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={handleToDateChange}
                        min={minDate}
                        max={maxDate}
                      />
                    </div>
                    <div className="col-md-3 mt-2">
                      <button type="submit" className="btn btn-default mt-4">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filtereditemList}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filtereditemList?.length}
                onPageChange={handlePageChange}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handlePDF={handlePDF}
                handleView={handleView}
                handleGenerateEinvoice={handleGenerateEinvoice}
                handleSearchChange={handleSearchChange}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default InvoiceList;
